import { createContext, useContext, useState, useEffect } from 'react';

/**
 * AMAÇ: Dark / Light mode + renk paleti yönetimi
 * Seçimler localStorage'da saklanır, sonraki ziyarette hatırlanır
 * - Dark mode: <html class="dark"> (Tailwind class-based)
 * - Palet:    <html data-palette="gul"> (index.css'teki CSS değişkenleri)
 */

export const PALETTES = [
  { id: 'gokyuzu',   label: 'Gökyüzü',   swatch: '#7DA8E8', desc: 'Sakin pastel mavi' },
  { id: 'gul',       label: 'Gül',       swatch: '#E88DB8', desc: 'Yumuşak pembe' },
  { id: 'lavanta',   label: 'Lavanta',   swatch: '#9A8FE8', desc: 'Pastel mor' },
  { id: 'nane',      label: 'Nane',      swatch: '#63BC92', desc: 'Ferah yeşil' },
  { id: 'gunbatimi', label: 'Günbatımı', swatch: '#E88D66', desc: 'Sıcak mercan' },
  { id: 'safir',     label: 'Safir',     swatch: '#183882', desc: 'Zengin lacivert' },
];

const ThemeContext = createContext(null);

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(
    () => localStorage.getItem('streak_theme') || 'light'
  );
  const [palette, setPalette] = useState(
    () => localStorage.getItem('zincir_palette') || 'safir'
  );

  // Tema değişince <html> class'ını güncelle
  useEffect(() => {
    const root = document.documentElement;
    if (theme === 'dark') {
      root.classList.add('dark');
    } else {
      root.classList.remove('dark');
    }
    localStorage.setItem('streak_theme', theme);
  }, [theme]);

  // Palet değişince <html data-palette> güncelle
  useEffect(() => {
    document.documentElement.dataset.palette = palette;
    localStorage.setItem('zincir_palette', palette);
  }, [palette]);

  const toggleTheme = () => setTheme((t) => (t === 'light' ? 'dark' : 'light'));
  const isDark = theme === 'dark';

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme, isDark, palette, setPalette }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
